import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './ocorrenciaAutomaticaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, 
	getListaTipo, getListaMotorista, getListaUsuarioKmm
} from './ocorrenciaAutomaticaActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class OcorrenciaAutomatica extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			datahora_inicio: 1
		}
	}

	componentWillMount() {

		this.props.setModoTela('lista');

		this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaMotorista();
		this.props.getListaUsuarioKmm();

		this.idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaTipo();
			this.props.getListaMotorista();
			this.props.getListaUsuarioKmm();
		}, 30000);

	}

	componentWillUnmount() {

		if (this.idInterval) {
			clearInterval(this.idInterval);
		}

	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'validacao' ? (
						<Form validacao onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'visualizacao' ? (
						<Form visualizacao onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${item.shipping}
					${item.romaneio}
					${item.id_ocorrencia_kmm}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio)}
					${item.nomes_motoristas}
					${item.placas}
					${item.comentario}
					${item.usuario_inclusao_kmm}
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
					${item.comentario_aprovacao}
					${item.status}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		}).filter(item => {
			if (!this.props.usuarioCarregado) {
				return false;
			} else if (this.props.usuarioCarregado.acesso_ocorrencia) {
				return true;
			} else if (
				item.id_usuario_inclusao == this.props.usuarioCarregado.id
				|| item.id_usuario_responsavel == this.props.usuarioCarregado.id
				|| item.id_usuario_aprovador == this.props.usuarioCarregado.id
			) {
				return true;
			}
			return false;
		});

		if (this.state.ordenacao.shipping) {
			lista.sort((a, b) => this.state.ordenacao.shipping == 1 
				? (a.shipping > b.shipping ? 1 : -1) 
				: (a.shipping > b.shipping ? -1 : 1));
		} else if (this.state.ordenacao.romaneio) {
			lista.sort((a, b) => this.state.ordenacao.romaneio == 1 
				? (a.romaneio > b.romaneio ? 1 : -1) 
				: (a.romaneio > b.romaneio ? -1 : 1));
		} else if (this.state.ordenacao.id_ocorrencia_kmm) {
			lista.sort((a, b) => this.state.ordenacao.id_ocorrencia_kmm == 1 
				? (a.id_ocorrencia_kmm > b.id_ocorrencia_kmm ? 1 : -1) 
				: (a.id_ocorrencia_kmm > b.id_ocorrencia_kmm ? -1 : 1));
		} else if (this.state.ordenacao.datahora_inicio) {
			lista.sort((a, b) => this.state.ordenacao.datahora_inicio == 1 
				? (a.datahora_inicio > b.datahora_inicio ? 1 : -1) 
				: (a.datahora_inicio > b.datahora_inicio ? -1 : 1));
		} else if (this.state.ordenacao.nomes_motoristas) {
			lista.sort((a, b) => this.state.ordenacao.nomes_motoristas == 1 
				? (a.nomes_motoristas > b.nomes_motoristas ? 1 : -1) 
				: (a.nomes_motoristas > b.nomes_motoristas ? -1 : 1));
		} else if (this.state.ordenacao.placas) {
			lista.sort((a, b) => this.state.ordenacao.placas == 1 
				? (a.placas > b.placas ? 1 : -1) 
				: (a.placas > b.placas ? -1 : 1));
		} else if (this.state.ordenacao.comentario) {
			lista.sort((a, b) => this.state.ordenacao.comentario == 1 
				? (a.comentario > b.comentario ? 1 : -1) 
				: (a.comentario > b.comentario ? -1 : 1));
		} else if (this.state.ordenacao.usuario_inclusao_kmm) {
			lista.sort((a, b) => this.state.ordenacao.usuario_inclusao_kmm == 1 
				? (a.usuario_inclusao_kmm > b.usuario_inclusao_kmm ? 1 : -1) 
				: (a.usuario_inclusao_kmm > b.usuario_inclusao_kmm ? -1 : 1));
		} else if (this.state.ordenacao.datahora_inclusao) {
			lista.sort((a, b) => this.state.ordenacao.datahora_inclusao == 1 
				? (a.datahora_inclusao > b.datahora_inclusao ? 1 : -1) 
				: (a.datahora_inclusao > b.datahora_inclusao ? -1 : 1));
		} else if (this.state.ordenacao.comentario_aprovacao) {
			lista.sort((a, b) => this.state.ordenacao.comentario_aprovacao == 1 
				? (a.comentario_aprovacao > b.comentario_aprovacao ? 1 : -1) 
				: (a.comentario_aprovacao > b.comentario_aprovacao ? -1 : 1));
		} else if (this.state.ordenacao.status) {
			lista.sort((a, b) => this.state.ordenacao.status == 1 
				? (a.status > b.status ? 1 : -1) 
				: (a.status > b.status ? -1 : 1));
		}

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<Select
							maxWidth={200}
							options={this.props.listaCompetencias}
							label='Período'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							value={this.props.filtro.competencia}
							onChange={value => {
								if (value) {
									const periodo = DateFormat.getPeriodoCompetencia(value);
									this.props.setFiltro({
										...this.props.filtro,
										competencia: value,
										data_inicial: periodo ? periodo.data_inicial : this.props.filtro.data_inicial,
										data_final: periodo ? periodo.data_final : this.props.filtro.data_final
									});
								} else {
									this.props.setFiltro({
										...this.props.filtro,
										competencia: value
									});
								}
							}} />

						<LabelAndInputDate
							label='Data Inicial'
							cols='12 6 4 4'
							readOnly={parseInt(this.props.filtro.competencia) ? 'readOnly' : null}
							value={this.props.filtro.data_inicial}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_inicial: value
								});
							}} />

						<LabelAndInputDate
							label='Data Final'
							cols='12 6 4 4'
							readOnly={parseInt(this.props.filtro.competencia) ? 'readOnly' : null}
							value={this.props.filtro.data_final}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_final: value
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaStatus}
							label='Status'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_status}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_status: values.map(item => item.value)
								});
							}} />
								
						<Select
							maxWidth={400}
							options={this.props.listaMotorista}
							label='Motorista'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_motoristas}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_motoristas: values.map(item => item.value)
								});
							}} />

						<Select
							maxWidth={350}
							options={this.props.listaUsuarioKmm}
							label='Lançado por'
							cols=' 12 4 4 3'
							placeholder='Selecione'
							multiple
							value={this.props.filtro.ids_usuarios_kmm}
							onChange={values => {
								this.props.setFiltro({
									...this.props.filtro,
									ids_usuarios_kmm: values.map(item => item.value)
								});
							}} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
									this.props.getListaTipo();
									this.props.getListaMotorista();
									this.props.getListaUsuarioKmm();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									
									let listaValidarLote = lista.filter(item => item.status === 'Pendente');
									if (lista.length) {
										this.props.setModoTela('validacao', {
											...listaValidarLote[0],
											totalLote: listaValidarLote.length,
											executandoLote: 1,
											listaValidarLote: listaValidarLote.slice(1)
										});
										this.props.initForm({
											...listaValidarLote[0],
											totalLote: listaValidarLote.length,
											executandoLote: 1,
											listaValidarLote: listaValidarLote.slice(1)
										});
									}
								}}>
								<i class='fas fa-check-double'></i> Validar
							</a>

							<ExcelFile
								filename={'Pendências Automatizadas'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									datahora_inicio: DateFormat.formatarDataSqlParaTela(item.datahora_inicio),
									datahora_inclusao: DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)
								}))} name='Pendências Automatizadas'>
									<ExcelColumn label='Shipping' value='shipping' />
									<ExcelColumn label='Romaneio' value='romaneio' />
									<ExcelColumn label='ID KMM' value='id_ocorrencia_kmm' />
									<ExcelColumn label='Data Início' value='datahora_inicio' />
									<ExcelColumn label='Motorista' value='nomes_motoristas' />
									<ExcelColumn label='Placa' value='placas' />
									<ExcelColumn label='Descrição da Ocorrência' value='comentario' />
									<ExcelColumn label='Usuário Lançamento' value='usuario_inclusao_kmm' />
									<ExcelColumn label='Inclusão' value='datahora_inclusao' />
									<ExcelColumn label='Comentário' value='comentario_aprovacao' />
									<ExcelColumn label='Status' value='status' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 260}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 260}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 340}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 260}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 260}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { shipping: this.getNovaOrdenacao(this.state.ordenacao.shipping) }})} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Shipping {this.getIconeOrdenacao(this.state.ordenacao.shipping)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { romaneio: this.getNovaOrdenacao(this.state.ordenacao.romaneio) }})} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Romaneio {this.getIconeOrdenacao(this.state.ordenacao.romaneio)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { id_ocorrencia_kmm: this.getNovaOrdenacao(this.state.ordenacao.id_ocorrencia_kmm) }})} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>ID KMM {this.getIconeOrdenacao(this.state.ordenacao.id_ocorrencia_kmm)}</Th>
									<Th paddingTop={2} paddingBottom={2}
										onClick={() => this.setState({ ...this.state, ordenacao: { datahora_inicio: this.getNovaOrdenacao(this.state.ordenacao.datahora_inicio) } })}
										sticky width={40} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data Início {this.getIconeOrdenacao(this.state.ordenacao.datahora_inicio)}</Th>
									<Th paddingTop={2} paddingBottom={2}
										onClick={() => this.setState({ ...this.state, ordenacao: { nomes_motoristas: this.getNovaOrdenacao(this.state.ordenacao.nomes_motoristas) }})}
										sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Motorista {this.getIconeOrdenacao(this.state.ordenacao.nomes_motoristas)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { placas: this.getNovaOrdenacao(this.state.ordenacao.placas) }})} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Placa {this.getIconeOrdenacao(this.state.ordenacao.placas)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { comentario: this.getNovaOrdenacao(this.state.ordenacao.comentario) }})} 
										sticky width={300} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Descrição da Ocorrência {this.getIconeOrdenacao(this.state.ordenacao.comentario)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { usuario_inclusao_kmm: this.getNovaOrdenacao(this.state.ordenacao.usuario_inclusao_kmm) }})} 
										sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Usuário Lançamento {this.getIconeOrdenacao(this.state.ordenacao.usuario_inclusao_kmm)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { datahora_inclusao: this.getNovaOrdenacao(this.state.ordenacao.datahora_inclusao) }})} 
										sticky width={300} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Inclusão {this.getIconeOrdenacao(this.state.ordenacao.datahora_inclusao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { comentario_aprovacao: this.getNovaOrdenacao(this.state.ordenacao.comentario_aprovacao) }})} 
										sticky width={300} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Comentário {this.getIconeOrdenacao(this.state.ordenacao.comentario_aprovacao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { status: this.getNovaOrdenacao(this.state.ordenacao.status) }})} 
										sticky width={80} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status {this.getIconeOrdenacao(this.state.ordenacao.status)}</Th>

									<Th paddingTop={2} paddingBottom={2} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Ações'></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td minWidth={50} color={'#000'} alignCenter small>{item.shipping}</Td>
										<Td minWidth={50} color={'#000'} alignCenter small>{item.romaneio}</Td>
										<Td minWidth={50} color={'#000'} alignCenter small>{item.id_ocorrencia_kmm}</Td>
										<Td minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.datahora_inicio)}</Td>
										<Td minWidth={200} color={'#000'} alignCenter small>
											{item.conjuntos.length > 1 && 
											<i class='fas fa-exclamation-circle' style={{ color: '#ff0000', marginRight: 8 }} title='Mais de um motorista encontrado'></i>}
											{item.nomes_motoristas}
										</Td>
										<Td minWidth={50} color={'#000'} alignCenter small>{item.placas}</Td>
										<Td minWidth={300} color={'#000'} alignCenter small>{item.comentario}</Td>
										<Td minWidth={100} color={'#000'} alignCenter small>{item.usuario_inclusao_kmm}</Td>
										<Td minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
										<Td minWidth={300} color={'#000'} alignCenter small>{item.comentario_aprovacao}</Td>
										<Td minWidth={100} alignCenter>
											<span
												style={{
													display: 'inline-block',
													padding: '4px 10px',
													borderRadius: '999px',
													fontSize: 12,
													fontWeight: 600,
													color:
														item.status === 'Aprovada'
															? '#166534'
															: item.status === 'Reprovada'
															? '#991B1B'
															: '#374151',
													backgroundColor:
														item.status === 'Aprovada'
															? '#bce6ca'
															: item.status === 'Reprovada'
															? '#e8b3b3'
															: '#cfd1d4',
												}}
											>
												{item.status}
											</span>
										</Td>
										<Td minWidth={100} alignCenter>
											{item.status === 'Pendente' &&
											<ButtonTable
												type={'secondary'}
												icon={'fas fa-check'}
												visible={true}
												small
												title='validar'
												event={() => {
													this.props.setModoTela('validacao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />}

											{item.status === 'Pendente' &&
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />}

											{item.status !== 'Pendente' &&
											<ButtonTable
												type={'primary'}
												icon={'fas fa-eye'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('visualizacao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />}
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.ocorrenciaAutomatica.aguardando,
	modoTela: state.ocorrenciaAutomatica.modoTela,
	lista: state.ocorrenciaAutomatica.lista,
	filtro: state.ocorrenciaAutomatica.filtro,
	listaTipo: state.ocorrenciaAutomatica.listaTipo,
	listaMotorista: state.ocorrenciaAutomatica.listaMotorista,
	listaUsuarioKmm: state.ocorrenciaAutomatica.listaUsuarioKmm,
	listaStatus: state.ocorrenciaAutomatica.listaStatus,
	listaCompetencias: state.ocorrenciaAutomatica.listaCompetencias
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, 
	getListaTipo, getListaMotorista, getListaUsuarioKmm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OcorrenciaAutomatica);
